<template>
  <div class="mt-1">
    <b-row v-if="showErrorInfo">
      <b-col offset="3" cols="9">
        <small class="text-danger">
            Należy wybrać warstwę odniesienia.
        </small>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <label for="referenceLayerSelect">Warstwa odniesienia</label>
      </b-col>
      <b-col cols="9">
        <b-form-select :disabled="readonly" id="referenceLayerSelect" v-model="selectedReferenceLayer" :options="referenceLayers" :state="showErrorInfo ? false : null">
          <template slot="first">
            <option v-if="readonly" :value="null">Warstwa aktywna</option>
            <option v-else :value="null">Wybierz</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => null },
    readonly: { type: Boolean, default: false },
    referenceLayers: { type: Array, default: () => [] },
    showErrorInfo: Boolean
  },
  computed: {
    selectedReferenceLayer: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    },
  }
}
</script>
